export const scrollToCompra = () => {
  const element = document.getElementById('compra')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}
